import LabServiceCollection from "@/collections/LabServiceCollection";
import ScheduleSampleModel from "@/models/lab/ScheduleSampleModel";

export default class ScheduleSampleCollection extends LabServiceCollection {

    model() {
        return ScheduleSampleModel;
    }

}